import { useRole } from "../redux/features/user";
import { useServerActions } from "../redux/features/permissions/permissionsSlice";

export const useCheckPermission = (action) => {
  const role = useRole();
  const serverActions = useServerActions();

  if (role === "GRANT_ADMIN") {
    return true;
  }

  if (action === "UNLOCK") {
    return role === "AML_MANAGER";
  }

  if (action === "ASSIGN_TO") {
    return role === "AML_MANAGER";
  }

  const actionObj = serverActions.find((e) => e.action === action);
  const roleObj = actionObj?.roles.find((e) => e.role === role);

  return Boolean(roleObj?.selected);
};
